import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { browserHistory } from 'react-router'
import { 
    Toast, Form, FormCell, CellBody, Input, TextArea, Dialog,
    CellsTitle, Toptips,
} from 'react-weui'
import { getSdkVersion, isLZWKAPP, shouldLinkToAPP } from '../../utils'
import { updateSuccess } from '../../utils/connectApp'
import { Header, BottomBtn } from '../../components/liveroomLecturer'
import { Page, WKError } from '../../components'
import '../../css/page/LiveroomLecturerPage.css'
import errorImg from '../../images/no-source.png'
import Config from '../../config'


const SEX_LABEL = {
    0: '未知',
    1: '男',
    2: '女'
}

class ProfilePage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            file: '',
            name: '',
            desc: '',
            cover: '',
            isPending: false,
            pendingText: '',
            isSuccess: false,
            isInfo: false,
            infoText: '',
            isError: false,
            isTextAlert: false,
            isNameAlert: false,
            alert: {
                isAlert: false,
                alertMsg: '',
            },
            userInfo: {},
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            liveroom_id: '',
            verify_type: 0,
            is_government: 0,
        }
        this.isAnd = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
    }
    onClickTextArea () {
        if (this.isAnd) {
            setTimeout(() => {
                this.$textarea.scrollIntoView()
            }, 500)
        }
    }
    accountInfo() {
        axios.get(`/api/account/info`).then((res) => {
            const userInfo = this.state.userInfo
            const resultInfo = res.data.data
            this.setState({
                userInfo:{
                    ...userInfo,
                    name: resultInfo.name,
                    province: resultInfo.province,
                    sex: resultInfo.sex,
                    telephone: resultInfo.telephone
                }
            })
        }).catch((e) => {
            console.log(e)
        })
    }
    componentDidMount () {
        document.title = '直播间基本信息';

        //风控
        this.page.showFengKongTip()

        this.setState({ isPending: true })
        this.accountInfo()
        this.$textarea = document.querySelector('textarea')
        // document.querySelector('#profile-name').focus()
        axios.get(`/api/liveroom/${this.props.params.liveroom_id}/edit_info`)
            .then(res => {
                const liveroom = res.data.data.liveroom
                const userInfo = this.state.userInfo
                this.setState({
                    name: liveroom.name,
                    desc: liveroom.description,
                    cover: liveroom.avatar_url,
                    isPending: false,
                    liveroom_id: this.props.params.liveroom_id,
                    verify_type: liveroom.verify_type,
                    is_government: liveroom.is_government,
                    userInfo: {
                        ...userInfo,
                        ip_address: liveroom.ip_address
                    }
                })
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    this.setState({ isError: true })
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '网络连接出问题了。',
                            img: errorImg,
                            href: '/?st=liveroom_setting_main_404',
                            btn: '去首页看看'
                        }
                    })
                    return
                }
                if (error.response && error.response.status === 403) {
                    this.setState({ isError: true })
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '你没有查看权限。',
                            img: errorImg,
                            href: '/?st=liveroom_setting_main_403',
                            btn: '去首页看看'
                        }
                    })
                }
            })
    }
    bindValue (e, filed) {
        this.setState({ [filed]: e.target.value })
    }
    onChangeFile (e) {
        const file = e.target.files[0]
        if (!file) return
        const _this = this
        const reader = new FileReader();
        reader.onload = function(e) {
            _this.setState({ cover: this.result, file })
        }
        reader.readAsDataURL(file);
    }
    getBgClass (cover) {
        return cover ? 'fill' : ''
    }
    onSubmit () {
        const name = String(this.state.name).trim()
        const desc = String(this.state.desc).trim()
        const verifyRes = this.verify(name, desc)
        const from = this.props.location.query.from
        if (!verifyRes.status) {
            return this.page.showConfirm('温馨提示', verifyRes.msg)
            // return this.showTip(verifyRes.msg)
        }
        this.setState({ isPending: true, pendingText: '正在提交' })
        const liveroomId = this.props.params.liveroom_id
        const formData = new FormData()
        formData.append('name', name)
        formData.append('description', desc)
        if (this.state.file) {
            formData.append('avatar', this.state.file)
        }
        axios.post(`/api/liveroom/${liveroomId}/edit`, formData)
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.page.showConfirm('温馨提示', res.data.msg)
                    // return this.showTip(res.data.msg)
                }
                this.setState({ isSuccess: true })
                // 通知app更新页面信息
                updateSuccess({ type: 'liveroom' })
        
                if (from === 'liveroom_app') {
                    setTimeout(() => { browserHistory.go(-1) }, 1000)
                } else {
                    setTimeout(() => {
                        shouldLinkToAPP() 
                        ? location.assign(`lizhiweike://liveroom?liveroom_id=${liveroomId}`) 
                        : location.assign(`/liveroom/${liveroomId}`) 
                    }, 1000)
                }
                setTimeout(() => { this.setState({ isSuccess: false }) }, 999)
            })
    }
    verify (name, desc) {
        if (name.length > 30 || name.length < 1) {
            return { status: false, msg: '直播间名称为1-30个字符' }
        }
        return { status: true }
    }
    onClickFileInput (e) {
        if (window.systemType === 'android' && isLZWKAPP() && getSdkVersion() < 21) {
            this.setState({ alert: { isAlert: true, alertMsg: '检测到您设备Android版本太低，可能会造成图片上传失败，请您移步微信端进行操作，谢谢您为维护良好平台风气做出的支持！' } })
            e.preventDefault()
        }
    }
    showTip (text, type = 'warn') {   
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    verifyCompanyRender() {
        const verify_type = this.state.verify_type
        const is_government = this.state.is_government
        const htmlObj = {
            1: <div className="info-cell-desc-box">
                <img className="info-cell-desc-img" src="https://static-cos.lycheer.net/xupload/20220725_vip-yellow.png" />
                <span>个人认证</span>
            </div>,
            2: <div className="info-cell-desc-box">
                <img className="info-cell-desc-img" src="https://static-cos.lycheer.net/xupload/20220725_vip-blue.png" />
                <span>机构认证</span>
            </div> 
        }
        if(is_government === 1) {
            return <div className="info-cell-desc-box">
                <img className="info-cell-desc-img" src="https://static-cos.lycheer.net/xupload/20220725_vip-red.png" />
                <span>政府认证</span>
            </div>
        }
        return !!htmlObj[verify_type] ? htmlObj[verify_type] : '点击进行认证'
    }
    processName(str){
        if(!!Number(str)) {
            return str
        }
        if(str) {
            let star = '' //存放名字中间的*
            //名字是两位的就取姓名首位+*
            if(str.length >= 2){
              return str.substring(0,1)+"*" + str.substring(str.length-1,str.length) ;
            } else {
              for (let i = 0; i > str.length-2; i++) {
                star= star + '*'
              }
              return str.substring(0,1)+ star + str.substring(str.length-1,str.length);
            }
        }
        return ''
    }
    
    toInfomation() {
        const liveroomId = this.props.params.liveroom_id
        const href = `${Config.MAIN_URL}/management/liveroom/${liveroomId}/verify/information`;
        window.location.href = href
        // axios.get(`/api/account/is_realname_verified_n`).then((res) => {
        //     const { status } = res.data.data
        //     console.log(res, 'res')
        //     if (status === 3) {
        //         location.href = `${Config.MAIN_URL}/management/liveroom/${liveroomId}/verify/personal/`;
        //     } else {
        //         const href = `${Config.MAIN_URL}/management/liveroom/${liveroomId}/verify/information`;
        //         window.location.href = href
        //     }
        // }).catch((e) => {
        //     console.log(e)
        // })
    }
    
    render() {
        if (this.state.isError) {
            return <div style={{background: '#fff', position: 'fixed', width: '100%', height: '100%'}}>
                <WKError />
            </div>
        }
        const userName =  this.state.userInfo.name || ''
        return (
            <div className="liveroom-setting-profile">
                <Page parent={this}>
                    <div className="live-info-lable">直播间信息</div>
                    <div className="">
                        <ul className="info-cell-list">
                            <li className="info-cell-item-header">
                                <p className="info-cell-lab">直播间头像</p>
                                <div className={`weui-uploader__input-box ${this.getBgClass(this.state.cover)}`} style={{backgroundImage: `url(${this.state.cover})`}}>
                                    <input type="file" onClick={e => this.onClickFileInput(e)} onChange={e => this.onChangeFile(e)} className='weui-uploader__input' />
                                </div>
                            </li>
                            <li>
                                <p className="info-cell-lab">直播间名称</p>
                                <div className="info-cell-desc" onClick={() => {
                                        this.setState({
                                            isNameAlert: true
                                        })
                                    }}>
                                    <p className={`"info-cell-desc-edit" ${!this.state.name ? 'cell-desc-edit-pla' : ''}`}>{this.state.name || '请输入直播间名称'}</p>
                                    <img className="info-cell-arrow" src="https://static-cos.lycheer.net/xupload/20211130_Rigthallow_IRrgHf6.png" />
                                </div>
                            </li>
                            <li>
                                <p className="info-cell-lab">直播间id</p>
                                <p className="info-cell-desc">{this.state.liveroom_id}</p>
                            </li>
                            <li>
                                <p className="info-cell-lab">认证中心</p>
                                <div className="info-cell-desc" onClick={() => {
                                        this.toInfomation()
                                    }}>
                                    <div className={`info-cell-desc-flex ${this.verifyCompanyRender() === '点击进行认证' ? 'cell-desc-edit-pla' : ''}`}> 
                                        {/* {this.verifyCompanyRender()} */}
                                    </div>
                                    <img className="info-cell-arrow" src="https://static-cos.lycheer.net/xupload/20211130_Rigthallow_IRrgHf6.png" />
                                </div>
                            </li>
                            <li>
                                <p className="info-cell-lab">直播间介绍</p>
                                <div className="info-cell-desc" onClick={() => {
                                        this.setState({
                                            isTextAlert: true
                                        })
                                    }}>
                                    <p className={`info-cell-desc-edit ${!this.state.desc ? 'cell-desc-edit-pla' : ''}`}>{this.state.desc || '编辑'}</p>
                                    <img className="info-cell-arrow" src="https://static-cos.lycheer.net/xupload/20211130_Rigthallow_IRrgHf6.png" />
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="live-info-lable">账号信息</div>
                    <div className="">
                        <ul className="info-cell-list info-cell-list-gray">
                            <li>
                                <p className="info-cell-lab">创建者</p>
                                <p className="info-cell-desc">{this.processName(userName)}</p>
                            </li>
                            <li>
                                <p className="info-cell-lab">手机号</p>
                                <p className="info-cell-desc">{this.state.userInfo.telephone}</p>
                            </li>
                            <li>
                                <p className="info-cell-lab">性别</p>
                                <p className="info-cell-desc">{SEX_LABEL[this.state.userInfo.sex] || '未知'}</p>
                            </li>
                            <li>
                                <p className="info-cell-lab">所在地</p>
                                <p className="info-cell-desc">{this.state.userInfo.province}</p>
                            </li>
                            <li>
                                <p className="info-cell-lab">IP属地<span>（以运营商信息为准）</span></p>
                                <p className="info-cell-desc">{this.state.userInfo.ip_address}</p>
                            </li>
                        </ul>
                    </div>

                    <BottomBtn btnContent={{ text: '确定', method: () => this.onSubmit() }} />
                    <Toast icon="loading" show={this.state.isPending}>{this.state.pendingText || '正在获取数据'}</Toast>
                    <Toast icon="success-no-circle" show={this.state.isSuccess}>修改成功</Toast>
                    <Dialog type="ios" title='' show={this.state.isTextAlert} buttons={[{
                        label: '确定',
                        onClick: () => this.setState({ isTextAlert : false }),
                    }]}>
                        <CellBody>
                            <TextArea onClick={() => this.onClickTextArea()} showCounter={false} value={this.state.desc} onChange={e => this.bindValue(e, 'desc')} placeholder="请填写直播间介绍" rows="4"></TextArea>
                        </CellBody>
                    </Dialog>
                    <Dialog type="ios" title='' show={this.state.isNameAlert} buttons={[{
                        label: '确定',
                        onClick: () => this.setState({ isNameAlert : false }),
                    }]}>
                        <CellBody>
                            <TextArea onClick={() => this.onClickTextArea()} showCounter={false} value={this.state.name} onChange={e => this.bindValue(e, 'name')} placeholder="请输入直播间名称" rows="4"></TextArea>
                        </CellBody>
                    </Dialog>
                    <Dialog type="ios" title='' show={this.state.alert.isAlert} buttons={[{
                        label: '确定',
                        onClick: () => this.setState({ alert: { isAlert: false } }),
                    }]}>
                        {this.state.alert.alertMsg}
                    </Dialog>
                    <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                </Page>
            </div>
        )
    }
}


export default connect((state) => ({
	account: state.account
}))(ProfilePage)


// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/ProfilePage.js